export enum OneToOneStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ARCHIVED = 'ARCHIVED', 
  COMPLETED = 'COMPLETED'
}
